__webpack_require__.p = "https://suchtindex.infodrog.ch/gateway/";